module.exports = __webpack_public_path__ + "static/media/Artboard23.e1a2bc43.png";